import { render } from "./GenericModal.vue?vue&type=template&id=33412164&scoped=true"
import script from "./GenericModal.vue?vue&type=script&lang=js"
export * from "./GenericModal.vue?vue&type=script&lang=js"

import "./GenericModal.vue?vue&type=style&index=0&id=33412164&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33412164"]])

export default __exports__